import script from "./Brand.vue?vue&type=script&setup=true&lang=js"
export * from "./Brand.vue?vue&type=script&setup=true&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=6a42a451&lang=css"

const __exports__ = script;

export default __exports__